var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"hlx-section-title text-xs-center mb-4"},[_vm._v(_vm._s(_vm.$t("money_manager.payout_reason")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.payout.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }